import React, { useMemo, useCallback } from "react";
import QuestionChips from "../QuestionChips/QuestionChips";
import OptionChips from "../OptionChips/OptionChips";
import DisclaimerChatBlock from "../DisclaimerChatBlock/DisclaimerChatBlock";
import StarChatBlock from "../StarChatBlock/StarChatBlock";
import SpeakerChatBlock from "../SpeakerChatBlock/SpeakerChatBlock";
import FeedbackChatBlock from "../FeedbackChatBlock/FeedbackChatBlock";
import SourcesChatBlock from "../SourcesChatBlock/SourcesChatBlock";
import { getUserCadre, getUserKb } from "../../../Actions/Utils";
import FeedbackButtonBlock from "../FeedbackButtonBlock/FeedbackButtonBlock";
import Markdown from 'react-markdown'
import "./BotChatBlock.css"
import { answerMethods, answerTypes, botDisclaimerMessage, defaultChipBlockText, noAnswerDefaultBlockText, validatedSameMessage, welcomeMessageBlockText, welcomeMessageBlockTextSecond } from "../../../NewConstants/ChatConstants";
import { errorCodeMap, modelNotRespondingConstant } from "../../../NewConstants/ErrorConstants";
import { DEMOASHADefaultChipsList, CTDCHODefaultChipsList, WCDAWWDefaultChipsList, GAVIASHADefaultChipsList, BSHSFPCDefaultChipsList, POCANMDefaultChipsList } from "../../../NewConstants/OptionConstants";
import { FeedbackConstant, FeedbackValues } from "../../../NewConstants/FeedbackConstants";
import Tooltip from "../../../Core/Components/Tooltip/Tooltip";

const BotChatBlock = React.memo(({
  idx,
  followingIdx,
  welcomeIdx,
  selectedLanguage,
  item,
  speakerEnabled,
  initSpeechSynth = () => { },
  stopAudio = () => { },
  saveResponse = () => { },
  openSourceDialog = () => { },
  sendFeedback = () => { },
  time,
  textSize,
  disabled,
  markFavourite = () => { },
  start,
  setStartTour,
  onTourEnd,
  speakerOpen,
  setSpeakerOpen,
  defaultQuestionChipsClicked,
  setDefaultQuestionChipsClicked,
  questionChipClicked = () => {},
}) => {
  const language = item?.user?.language ? item?.user?.language : "en";
  const defaultChipMarkup = useMemo(() => ({ __html: defaultChipBlockText?.html[language] }), [language]);
  const noAnswerBlockMarkup = useMemo(() => ({ __html: noAnswerDefaultBlockText?.html[language] }), [language]);
  const welcomeMessageMarkup = useMemo(() => ({ __html: welcomeMessageBlockText?.html[language] }), [language]);
  const welcomeMessageMarkupsecond = useMemo(() => ({ __html: welcomeMessageBlockTextSecond?.html[language] }), [language]);
  
  const DefaultChipsLists = useMemo(() => ({
    DEMOASHADefaultChipsList,
    CTDCHODefaultChipsList,
    WCDAWWDefaultChipsList,
    GAVIASHADefaultChipsList,
    BSHSFPCDefaultChipsList,
    POCANMDefaultChipsList
  }), []);

  const listKey = useMemo(() => `${getUserKb()}${getUserCadre()}DefaultChipsList`, []);
  const chipsList = useMemo(() => DefaultChipsLists[listKey] || [], [DefaultChipsLists, listKey]);

  const markdownComponents = useMemo(() => ({
    h1: ({ children }) => <h1 style={{ fontSize: `${textSize * 1.5}rem`, fontWeight: 'bold', margin: '0.5rem 0' }}>{children}</h1>,
    h2: ({ children }) => <h2 style={{ fontSize: `${textSize * 1.3}rem`, fontWeight: 'bold', margin: '0.5rem 0' }}>{children}</h2>,
    h3: ({ children }) => <h3 style={{ fontSize: `${textSize * 1.1}rem`, fontWeight: 'bold', margin: '0.5rem 0' }}>{children}</h3>,
    p: ({ children }) => <p style={{ margin: '0.5rem 0' }}>{children}</p>,
  }), [textSize]);

  const handleMarkFavourite = useCallback((_, __, newStarFlag) => {
    markFavourite(idx, item?._id, newStarFlag);
  }, [idx, item?._id, markFavourite]);

  const handleSaveResponse = useCallback((index, input, isFollowup = false, image) => {
    saveResponse(index, input, isFollowup, image);
  }, [saveResponse]);
  

  const handleOpenSourceDialog = useCallback(() => {
    openSourceDialog(item?.bot?.sources, language);
  }, [item?.bot?.sources, openSourceDialog, language]);

  const handleSendFeedback = useCallback((feedback) => {
    sendFeedback(feedback);
  }, [sendFeedback]);

  const handleInitSpeechSynth = useCallback(() => {
    const optionsToSend = item?.bot?.welcome ? [] : item?.bot?.options;
    const textToSend = item?.bot?.welcome ? welcomeMessageBlockText?.audio[language] : item?.bot?.text[language];
    initSpeechSynth(idx, textToSend, optionsToSend, language);
  }, [idx, item?.bot?.text, item?.bot?.options, item?.bot?.welcome, initSpeechSynth, language]);

  const handleInitSpeechSynthFollowing = useCallback(() => {
    initSpeechSynth(followingIdx, defaultChipBlockText?.audio[item?.user?.language], item?.bot?.options, language);
  }, [followingIdx, initSpeechSynth,selectedLanguage, item?.bot?.options, language]);
  const handleInitSpeechSynthwelcome = useCallback(() => {
    initSpeechSynth(welcomeIdx, welcomeMessageBlockTextSecond?.audio[language], [], language);
  }, [welcomeIdx, initSpeechSynth, language ]);

  return (
    <div className='float-left relative flex flex-col leading-[1.5rem]'>
      {/* main message block */}
      {item?.bot?.text && (
        <div className="flex items-center justify-start tour-speaker-chat-block" id={`tour-narration-chat-block-${idx}`}>
          <div
            className={`relative mb-2 ${
              speakerEnabled === idx && item?.bot?.error?.code
                ? "flex items-start bg-[var(--primary-light-2)] border border-[var(--primary-medium)]"
                : speakerEnabled === idx
                ? "bg-[var(--primary-light-2)] border border-[var(--primary-medium)]"
                : item?.bot?.error?.code || Object.keys(item?.bot?.text || {}).length === 0
                ? `flex items-start bg-[var(--neutral-white)] text-[var(--disclaimer-1)]`
                : item?.bot?.starred
                ? " bg-[var(--star-yellow-3)] border border-[var(--star-yellow-2)]"
                : "bg-[var(--neutral-white)]"
            } w-fit max-w-[77.5%] text-[color:var(--almost-black)] rounded-t-lg rounded-br-lg`}
            style={{ fontSize: `${textSize}rem` }}
          >
            {(item?.bot?.error?.code || Object.keys(item?.bot?.text || {}).length === 0) && <img className="mt-5 pl-2 float-left" src="Assets/Images/info.svg" alt="info icon"/> }
            {!(item?.bot?.error?.code) && Object.keys(item?.bot?.text || {}).length > 0 && !item?.bot?.welcome && <div className="float-right m-3">
              <StarChatBlock idx={idx} id={item?._id} starred={item?.bot?.starred} mark={handleMarkFavourite} />
            </div>}
            <div className="mb-4 mt-4 mx-3">
              {item?.bot?.welcome ? (
                <div className='flex flex-col' dangerouslySetInnerHTML={welcomeMessageMarkup}></div>
              ) : Object.keys(item?.bot?.text || {}).length === 0 ? (
                <Markdown components={markdownComponents}>{modelNotRespondingConstant[language]}</Markdown>
              ) : (
                <Markdown components={markdownComponents}>{item?.bot?.text[item?.bot?.text[language] ? language : "en"]}</Markdown>
              )}
            </div>
            {item?.bot?.answer_type === answerTypes.Summarized && (
              <DisclaimerChatBlock
                selectedLanguage={language}
                text={botDisclaimerMessage}
              />
            )}
          </div>
          <div className="ml-4 flex flex-col gap-3">
            <SpeakerChatBlock
              idx={idx}
              title={Object.keys(item?.bot?.text || {}).length === 0 ? modelNotRespondingConstant[language] : item?.bot?.text[item?.bot?.text[language] ? language : "en"]}
              options={item?.bot?.welcome ? [] : item?.bot?.options}
              isPlaying={speakerEnabled === idx}
              startAudio={handleInitSpeechSynth}
              stopAudio={stopAudio}
              setSpeakerOpen={setSpeakerOpen}
              speakerOpen={speakerOpen}
            />
            {item?.bot?.sources?.length > 0 && (
              <SourcesChatBlock
                idx={idx}
                sourceData={item?.bot?.sources}
                openSourceDialog={handleOpenSourceDialog}
              />
            )}
          </div>
        </div>
      )}
      
      {item?.bot?.welcome && (
        <div className="flex items-center justify-start">
          <div
            className={`relative mb-2 ${
              speakerEnabled === welcomeIdx
                ? "bg-[var(--primary-light-2)] border border-[var(--primary-medium)]"
                : "bg-[var(--neutral-white)]"
            } w-fit max-w-[77.5%] text-[color:var(--almost-black)] rounded-t-lg rounded-br-lg`}
            style={{ fontSize: `${textSize}rem` }}
          >
            <div className="mb-4 mt-4 mx-3">
                <div className='flex flex-col' dangerouslySetInnerHTML={welcomeMessageMarkupsecond}></div> 
            </div>
          </div>
          <div className="ml-4 flex flex-col gap-3">
            <SpeakerChatBlock
              idx={welcomeIdx}
              title={welcomeMessageBlockTextSecond?.audio[language]}
              isPlaying={speakerEnabled === welcomeIdx}
              startAudio={handleInitSpeechSynthwelcome}
              stopAudio={stopAudio}
              setSpeakerOpen={setSpeakerOpen}
              speakerOpen={speakerOpen}
            />
          </div>
        </div>
      )}
      {/* welcome default block */}
      {(getUserKb() !== 'GHS') && (item?.bot?.welcome) && (
        <div className="flex items-center justify-start tour-speaker-chat-block" id={`tour-narration-chat-block-${followingIdx}`}>
          <div
            className={`relative mb-2 ${speakerEnabled === followingIdx ? 'bg-[var(--primary-light-2)] border border-[var(--primary-medium)]' : 'bg-[var(--neutral-white)]'} w-fit max-w-[77.5%] text-[color:var(--almost-black)] rounded-t-lg rounded-br-lg`}
            style={{ fontSize: `${textSize}rem` }}
          >
            <div className="mb-8 mt-4 mx-3" dangerouslySetInnerHTML={defaultChipMarkup}>
            </div>
          </div>
          <div className="ml-4 flex flex-col gap-3">
            <SpeakerChatBlock
              idx={followingIdx}
              title={defaultChipBlockText?.audio[language]}
              options={item?.bot?.options}
              isPlaying={speakerEnabled === followingIdx}
              startAudio={handleInitSpeechSynthFollowing}
              stopAudio={stopAudio}
              setSpeakerOpen={setSpeakerOpen}
              speakerOpen={speakerOpen}
            />
            {item?.bot?.sources?.length > 0 && (
              <SourcesChatBlock
                idx={followingIdx}
                sourceData={item?.bot?.sources}
                openSourceDialog={handleOpenSourceDialog}
              />
            )}
          </div>
        </div>
      )}
      {/* no answer child message block */}
      {(getUserKb() !== 'GHS') && (item?.bot?.error?.code === errorCodeMap["No Answer"]) && (
        <div className="flex items-center justify-start">
          <div
            className={`relative mb-2 ${speakerEnabled === followingIdx ? 'bg-[var(--primary-light-2)] border border-[var(--primary-medium)]' : 'bg-[var(--neutral-white)]'} w-fit max-w-[77.5%] text-[color:var(--almost-black)] rounded-t-lg rounded-br-lg`}
            style={{ fontSize: `${textSize}rem` }}
          >
            <div className="mb-8 mt-4 mx-3" dangerouslySetInnerHTML={noAnswerBlockMarkup}>
            </div>
          </div>
          <div className="ml-4 flex flex-col gap-3">
            <SpeakerChatBlock
              idx={followingIdx}
              title={noAnswerDefaultBlockText?.audio[language]}
              options={[]}
              isPlaying={speakerEnabled === followingIdx}
              startAudio={handleInitSpeechSynth}
              stopAudio={stopAudio}
              setSpeakerOpen={setSpeakerOpen}
              speakerOpen={speakerOpen}
            />
          </div>
        </div>
      )}
      {/* chips block */}
      {item?.bot?.options?.length > 0 ? (
        item?.bot?.welcome ? (
          <div className={`mr-2 grid grid-cols-2 grid-rows-2 gap-2 mb-2 ${disabled ? 'pointer-events-none' : ''}`}>
            {chipsList.map((option, index) => {
              return (
                <OptionChips
                  key={option.id}
                  option={option}
                  selectedLanguage={language}
                  send={handleSaveResponse}
                  disabled={disabled}
                  index={index}
                  selectedChipIndex={item?.bot?.selectedChipIndex}
                  textSize={textSize}
                  idx={idx}
                />
              );
            })}
          </div>
        ) : (
          <div className={`z-20 ml-4 w-fit max-w-[77.5%] mt-[-1.5rem] ${disabled ? 'pointer-events-none' : ''}`}>
            <QuestionChips
              selectedLanguage={language}
              options={item?.bot?.options}
              saveResponse={handleSaveResponse}
              disabled={disabled}
              selectedChipIndex={item?.bot?.selectedChipIndex}
              textSize={textSize}
              idx={idx}
              defaultQuestionChipsClicked={defaultQuestionChipsClicked}
              setDefaultQuestionChipsClicked={setDefaultQuestionChipsClicked}
              questionChipClicked={questionChipClicked}
            />
          </div>
        )
      ) : null}
      {/* bot timestamp */}
      <div className="text-xs text-[color:var(--dark-neutral-2)] px-3 mb-2">
        {time}
      </div>
      {/* feedback block */}
      {item?.bot?.take_feedback &&  (
          <div 
            className={`relative p-3 ${item?.bot?.feedback_type !== '' ? 'mb-14' : 'mb-2'} bg-[var(--neutral-white)] w-fit max-w-[77.5%] text-[color:var(--almost-black)] rounded-t-lg rounded-br-lg ${disabled ? 'pointer-events-none' : ''}`}
            style={{ fontSize: `${textSize}rem` }}
          >
            {FeedbackConstant.title[language]}
            {
              item?.bot?.feedback_type === '' ? 
                <FeedbackChatBlock sendFeedback={handleSendFeedback} selectedLanguage={language}></FeedbackChatBlock>
                : 
                <div className="absolute right-[-2rem] bottom-[-3rem]">
                    <FeedbackButtonBlock  feedback={item?.bot?.feedback_type} selectedLanguage={language} />
                </div>
              }
          </div>
      )}
      {/* new feedback response flow */}
      {(item?.bot?.answer_type === answerTypes.Summarized) && 
       (item?.bot?.answer_method === answerMethods.QA) && 
       (item?.bot?.feedback_type === FeedbackValues.DISLIKE) ? (
        <div>
          <div
            className={`${item["bot"]["welcome"] ? "pb-3" : ""} flex items-center justify-start`}
          >
            <div 
              className={`${speakerEnabled === followingIdx ? 'bg-[var(--primary-light-2)] border border-[var(--primary-medium)]' : 'bg-[var(--neutral-white)]'} w-fit max-w-[77.5%] text-[color:var(--almost-black)] rounded-t-lg rounded-br-lg`}
              style={{ fontSize: `${textSize}rem` }}
            >
              <div className={`mb-${item["bot"]["welcome"] ? "4" : "8"} mt-4 mx-3`}>
                {item?.bot?.suggested_questions?.title[item?.bot?.suggested_questions?.title[language] ? language : "en"]}
              </div>
            </div>
            <div className="ml-4">
              <SpeakerChatBlock
                idx={followingIdx}
                title={item?.bot?.suggested_questions?.title[language]}
                options={item?.bot?.suggested_questions?.options}
                isPlaying={speakerEnabled === followingIdx}
                startAudio={handleInitSpeechSynth}
                stopAudio={stopAudio}
                setSpeakerOpen={setSpeakerOpen}
                speakerOpen={speakerOpen}
              />
            </div>
          </div>
          {item?.bot?.suggested_questions?.options ? (
            <div className={`ml-4 w-fit max-w-[77.5%] mt-[-0.5rem] ${disabled ? 'pointer-events-none' : ''}`}>
              <QuestionChips
                selectedLanguage={language}
                options={item?.bot?.suggested_questions?.options}
                saveResponse={handleSaveResponse}
                disabled={disabled}
                selectedChipIndex={item?.bot?.selectedChipIndex}
                textSize={textSize}
                idx={idx}
                defaultQuestionChipsClicked={defaultQuestionChipsClicked}
                setDefaultQuestionChipsClicked={setDefaultQuestionChipsClicked}
                questionChipClicked={questionChipClicked}
              />
            </div>
          ) : (
            <div className={`mr-6 grid grid-cols-2 grid-rows-2 gap-3 mb-4 ${disabled ? 'pointer-events-none' : ''}`}>
              {chipsList.map((option, index) => (
                <OptionChips
                  key={option.id}
                  option={option}
                  selectedLanguage={language}
                  send={handleSaveResponse}
                  disabled={disabled}
                  index={index}
                  selectedChipIndex={item?.bot?.selectedChipIndex}
                  textSize={textSize}
                  idx={idx}
                />
              ))}
            </div>
          )}
        </div>
      ) : (item?.bot?.answer_type === answerTypes.Summarized || 
           item?.bot?.answer_type === answerTypes.Validated || 
           item?.bot?.answer_type === answerTypes.NotValidated) && 
          (item?.bot?.answer_method === answerMethods.QA || 
           item?.bot?.answer_method === answerMethods.PAGE_SEARCH) && 
          (item?.bot?.feedback_type === FeedbackValues.LIKE || 
           item?.bot?.feedback_type === FeedbackValues.DISLIKE) ? (
        <div className="p-3 mb-2 bg-[var(--neutral-white)] w-fit max-w-[77.5%] text-[color:var(--almost-black)] rounded-t-lg rounded-br-lg" 
             style={{ fontSize: `${textSize}rem` }}>
          {validatedSameMessage[language]}
        </div>
      ) : null}
    </div>
  );
});

BotChatBlock.displayName = 'BotChatBlock';

export default BotChatBlock;
